export default { sha: '5afff6cc07cfcd2db524cdc536a2d70e7f96a058', buildNumber: 'undefined' }
